import * as React from "react";
import { useEffect } from "react";
import { Button } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { HashLink } from "react-router-hash-link";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const drawerWidth = 240;

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    color: "rgba(0, 0, 0, 1)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

function handleContrastClick() {
  const currentColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--akzent-color");
  if (currentColor == "#9eafb7") {
    document.documentElement.style.setProperty("--akzent-color", "#000000");
    document.documentElement.style.setProperty(
      "--akzent-background",
      "#FFFFFF"
    );
    document.documentElement.style.setProperty("--akzent-text", "#000000");
    document.documentElement.style.setProperty("--akzent-hover", "#FFFFFF");
    document.documentElement.style.setProperty("--akzent-hovertext", "#000000");
  } else {
    document.documentElement.style.setProperty("--akzent-color", "#9eafb7");
    document.documentElement.style.setProperty(
      "--akzent-background",
      "#000000"
    );
    document.documentElement.style.setProperty("--akzent-text", "#FFFFFF");
    document.documentElement.style.setProperty("--akzent-hover", "#FFFFFF");
    document.documentElement.style.setProperty("--akzent-hovertext", "#000000");
  }
}

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box sx={{ textAlign: "left" }}>
      {/* <Typography variant="h6" sx={{ my: 2, fontWeight: 300, lineHeight: 1.2, textAlign: 'center' }} className='drawerTitle'>
        <a href="/" className='navTitleLinkblack'>Notariat Kreußlein</a>
      </Typography> */}
      <Divider />
      {/* <NavLink to="/#leistungen" className='navItemDrawer'>Leistungen</NavLink>
            <NavLink to="/#kontakt" className='navItemDrawer'>Kontakt</NavLink> */}
      <HashLink
        className="navItemDrawer"
        smooth
        to="/#leistungen"
        onClick={handleDrawerToggle}
      >
        Leistungen
      </HashLink>
      <HashLink
        className="navItemDrawer"
        smooth
        to="/#notare"
        onClick={handleDrawerToggle}
      >
        Notare
      </HashLink>
      <HashLink
        className="navItemDrawer"
        smooth
        to="/article"
        onClick={handleDrawerToggle}
      >
        Entscheidungen
      </HashLink>
      <HashLink
        className="navItemDrawer"
        smooth
        to="/karriere#"
        onClick={handleDrawerToggle}
      >
        Karriere
      </HashLink>
      <HashLink
        className="navItemDrawer"
        smooth
        to="/#kontakt"
        onClick={handleDrawerToggle}
      >
        Kontakt
      </HashLink>
      {/* <HashLink className='navItemDrawer' smooth to="https://dialog.holland-kreusslein.de/">Zum Mandantenportal</HashLink> */}
      <Button
        className="navItemDrawer contrastbutton-mobile contrastClick"
        onClick={handleContrastClick}
      >
        Kontrastmodus{" "}
        <img src="color-icon.png" alt="Kontrast-Icon für den Kontrastmodus" />
      </Button>
      <div className="naviCTAWrapperMob">
        <Button
          href="https://dino.holland-kreusslein.de/"
          target="_blank"
          variant="contained"
          className="btnSecondary2b"
          onClick={handleDrawerToggle}
        >
          Mandanten-Login
          <TrendingFlatIcon className="secondaryBtnIcon" />
        </Button>
      </div>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component="nav" className="navbar">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            className="drawerTitle"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            <a href="/">
              {" "}
              <img
                src="Embem.png"
                className="brandLogo"
                alt="Holland und Kreusslein Emblem"
              />{" "}
            </a>
          </Typography>
          <Box
            sx={{ display: { xs: "none", md: "flex" } }}
            className="navLinksBox"
          >
            {/* <NavLink to="/#leistungen">Leistungen</NavLink>
            <NavLink to="/#kontakt">Kontakt</NavLink> */}
            <HashLink smooth to="/#leistungen">
              Leistungen
            </HashLink>
            <HashLink smooth to="/#notare">
              Notare
            </HashLink>
            <HashLink smooth to="/article">
              Entscheidungen
            </HashLink>
            <HashLink smooth to="/karriere#">
              Karriere
            </HashLink>
            <HashLink smooth to="/#kontakt">
              Kontakt
            </HashLink>
            {/* <HashLink smooth to="https://dialog.holland-kreusslein.de/">Zum Mandantenportal</HashLink> */}
            <LightTooltip
              title="Aktivieren Sie den Kontrastmodus für eine bessere Lesbarkeit"
              placement="bottom-start"
              arrow
            >
              <Button
                className="contrastbutton contrastClick"
                onClick={handleContrastClick}
              >
                <img
                  src="color-icon.png"
                  alt="Kontrast-Icon für den Kontrastmodus"
                />
              </Button>
            </LightTooltip>
            <div className="naviCTAWrapper">
              <Button
                href="https://dino.holland-kreusslein.de/"
                target="_blank"
                variant="contained"
                className="btnSecondary2b"
              >
                Mandanten-Login
                <TrendingFlatIcon className="secondaryBtnIcon" />
              </Button>
            </div>
          </Box>
          {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <ColorButton variant="contained" size="small" className='navbarButton'>Online Terminvereinbarung</ColorButton>
          </Box> */}
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          anchor={"right"}
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

export default DrawerAppBar;
